import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "ascention-reduced-motion";

export function useReducedMotion() {
  const [reducedMotion, setReducedMotion] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (reducedMotion) {
      root.classList.add("reduce-motion");
    } else {
      root.classList.remove("reduce-motion");
    }
    try {
      localStorage.setItem(STORAGE_KEY, String(reducedMotion));
    } catch {}
  }, [reducedMotion]);

  const toggle = useCallback(() => setReducedMotion(prev => !prev), []);

  return { reducedMotion, toggle };
}
